/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SettlementDetailContract} from '../../api/contracts/settlement-detail.contract';
import {SettlementDetailModel} from './settlement-detail.model';

export class SettlementDetailMapper {
    private constructor() {
    }

    static fromSettlementChangeDetailContract(input: SettlementDetailContract): SettlementDetailModel {
        let model: SettlementDetailModel = null;

        if (input != null) {
            model = {
                customer: input.customer,
                supplier: input.supplier,
                material: input.material,
                complaintCode: input.complaintCode,
                settlementCode: input.settlementCode,
                status: input.status,
                lastPendingDate: input.lastPendingDate,
                lastChangeDatetime: input.lastChangeDatetime,
                materialsTotalGrossCost: input.materialsTotalGrossCost,
                teMinutesTotalCost: input.teMinutesTotalCost,
                settlementTotalCost: input.settlementTotalCost,
                currency: input.currency,
                contactManager: input.contactManager,
                complaintDescription: input.complaintDescription,
                settlementPositions: input.settlementPositions != null ? [...input.settlementPositions] : undefined,
                decisionReason: input.decisionReason,
                availableActions: input.availableActions != null ? [...input.availableActions] : undefined,
                decidedBy: input.decidedBy,
                isTodo: input.isTodo
            };
        }
        return model;
    }
}
